import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "page-wrapper clearfix"
};
const _hoisted_2 = {
  class: "banner-container"
};
const _hoisted_3 = {
  class: "search-input"
};
const _hoisted_4 = {
  class: "search-input-wrapper"
};
const _hoisted_5 = {
  class: "search-box"
};
const _hoisted_6 = {
  key: 0,
  class: "prefix-icon",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202505/8148465033354e4e9120abc108ab1321.png"
};
const _hoisted_7 = {
  key: 1,
  class: "prefix-icon",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/eac823de206e461bad1b7701737507a5.png"
};
const _hoisted_8 = {
  class: "search-btn"
};
const _hoisted_9 = {
  class: "select-box-container"
};
const _hoisted_10 = {
  class: "owin-height"
};
const _hoisted_11 = {
  class: "news-container"
};
const _hoisted_12 = {
  key: 0,
  class: "news-left"
};
const _hoisted_13 = {
  key: 1,
  class: "news-right"
};
const _hoisted_14 = {
  class: "login-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_latestActivity = _resolveComponent("latestActivity");
  const _component_news = _resolveComponent("news");
  const _component_notice = _resolveComponent("notice");
  const _component_Footer = _resolveComponent("Footer");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createBlock(_component_el_config_provider, {
    locale: _ctx.locale
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Head, {
      pageUrl: `${_ctx.$baseUrl}/index.html`
    }, null, 8, ["pageUrl"]), _createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("img", {
      src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/71da610d97ac419680afe64531f81bbf.png"
    }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_ctx.searchValue.length > 0 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : (_openBlock(), _createElementBlock("img", _hoisted_7)), _createVNode(_component_el_input, {
      onKeyup: _withKeys(_ctx.searchCase, ["enter"]),
      class: _normalizeClass(["search-input-box", {
        'active': _ctx.searchValue.length > 0
      }]),
      placeholder: "请输入关键字",
      modelValue: _ctx.searchValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.searchValue = $event)
    }, null, 8, ["onKeyup", "class", "modelValue"])]), _createElementVNode("div", _hoisted_8, [_ctx.searchValue.length > 0 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.searchCase && _ctx.searchCase(...args)),
      src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/50156fb197f54e82ab5e1d78b029e28c.png"
    })) : (_openBlock(), _createElementBlock("img", {
      key: 1,
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.searchCase && _ctx.searchCase(...args)),
      src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/88ac27e6c2634a85a765ace8c31d4d65.png"
    }))]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_select, {
      "popper-class": "select-box-popover",
      class: "select-box-inner",
      modelValue: _ctx.selectTypeId,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.selectTypeId = $event),
      placeholder: "请选择"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectType, item => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.id,
          label: item.name,
          value: item.id
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])])])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_latestActivity), _createElementVNode("div", _hoisted_11, [_ctx.newsModule ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_news, {
      newsModule: _ctx.newsModule
    }, null, 8, ["newsModule"])])) : _createCommentVNode("", true), _ctx.noticeModule ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_notice, {
      noticeModule: _ctx.noticeModule
    }, null, 8, ["noticeModule"])])) : _createCommentVNode("", true)])]), _createElementVNode("footer", _hoisted_14, [_createVNode(_component_Footer)])])]),
    _: 1
  }, 8, ["locale"]);
}